module.exports = __webpack_public_path__ + "static/seawall_v2-1ada7c6c98932582ebc74b090e260613.jpg";